import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormFieldConfig, MedicationLookupConfig } from 'src/app/form-template/form-template-model';

@Component({
  selector: 'csi-form-template-medications-field-generator',
  templateUrl: './form-template-medications-field-generator.component.html',
  styleUrls: ['./form-template-medications-field-generator.component.css']
})
export class FormTemplateMedicationsFieldGeneratorComponent implements OnInit {
  @Input() config: FormFieldConfig & { typeConfig: MedicationLookupConfig };
  @Input() control: FormControl;
  @Input() formTemplateGroupFormGroup: FormGroup;
  @Input() formTemplateFieldKey: string;
  @Input() readOnly: boolean;
  @Input() formatForPDF: boolean;
  @Input() supportingFields: { [key: string]: FormFieldConfig };
  constructor() {}

  ngOnInit() {}
}
